


































import {Component, Vue} from "vue-property-decorator";
import {UnitSystem} from "@/interfaces/units";
import {lccaStore} from "@/store/store";
import CriticalLocationDepthInspector
  from "@/modules/perRoad/views/components/inspection/CriticalLocationDepthInspector.vue";
import CriticalLocationLayoutInspector
  from "@/modules/perRoad/views/components/inspection/CriticalLocationLayoutInspector.vue";
import InspectorThreeJS from "@/modules/perRoad/views/components/inspection/InspectorThreeJS.vue";
import {$httpLea} from "@/main";
import {
  IPrMonteCarloDrawImperial,
  IWesleaConfigBatch,
  IWesleaResultBatch
} from "@/modules/perRoad/interfaces/monteCarlo";
import HorizontalStrainDistributionResults
  from "@/modules/perRoad/views/components/monteCarloResults/HorizontalStrainDistributionResults.vue";
import PrHorizontalStrainDistributionPlot
  from "@/modules/perRoad/views/components/criteria/plots/PrHorizontalStrainDistributionPlot.vue";
import {
  getHorizontalStrainValuesFromWesleaResults,
  getPercentileAtValue
} from "@/modules/perRoad/lib/calculations/horizontalStrainDistribution";
import {IPavementStructureScenarioImperial} from "@/modules/structure/interfaces/pavementStructure";
import {LayerPerformanceCriteriaLocation} from "@/modules/perRoad/interfaces/perRoad";
import {getCurrentError} from "@/modules/perRoad/lib/simulation/optimization";
import Optimization from "@/modules/perRoad/views/components/Optimization.vue";

@Component({
  components: {
    Optimization,
    PrHorizontalStrainDistributionPlot,
    HorizontalStrainDistributionResults,
    InspectorThreeJS,
    CriticalLocationLayoutInspector,
    CriticalLocationDepthInspector,
  },
})
export default class WesleaDevFixture extends Vue {

  plotKey = 0;

  distributionPercentiles = [95, 85, 75, 65, 55];
  distribution_ustrain = [257, 194, 158, 131, 110];

  scenario: IPavementStructureScenarioImperial | null = null;
  draws: IPrMonteCarloDrawImperial[] = [];
  wesleaConfigs: IWesleaConfigBatch = {};
  wesleaResults: IWesleaResultBatch = {};


  get currentError() {
    return getCurrentError(this.resultTable);

  }

  get numUniqueDraws() {
    return [...new Set(this.draws.map(d => d.id))].length;

  }

  get baseHorizontalStrainValues() {
    return getHorizontalStrainValuesFromWesleaResults(this.draws, 1, LayerPerformanceCriteriaLocation.BOTTOM);
  }

  get percentileAtTargetStrain(): number[] {
    let actualPercentiles: number[] = [];

    if (this.distribution_ustrain && this.distributionPercentiles) {
      actualPercentiles = getPercentileAtValue(
          this.baseHorizontalStrainValues,
          this.distribution_ustrain,
          this.distributionPercentiles,
      );
    }

    return actualPercentiles;
  }

  get resultTable() {
    if (this.distributionPercentiles && this.distribution_ustrain) {
      return this.distributionPercentiles.map((pct, i) => ({
        // @ts-ignore
        uStrain: this.distribution_ustrain[i],
        targetPct: pct,
        actualPct: this.percentileAtTargetStrain[i] * 100,
        isSuccess: pct < this.percentileAtTargetStrain[i] * 100,
      }));
    }

    return [];
  }

  get isResultGood(): boolean {
    return true;
  }

  updatePlotKey() {
    this.plotKey += 1;
  }

  sync() {
    this.updatePlotKey();
    this.$emit("sync");
  }

  unitSystemIsImperial() {
    return lccaStore.displayUnits === UnitSystem.Imperial;
  }

  mounted() {
    $httpLea.get(`test/faildata`).then(result => {
      const data = result.data;
      console.log(data);
      this.scenario = data.scenario;
      this.draws = data.draws;
      this.wesleaConfigs = data.wesleaConfigs;
      this.wesleaResults = data.wesleaResults;
    });
  }

}
